import { render } from "./MiListItem.vue?vue&type=template&id=771a1536&scoped=true"
import script from "./MiListItem.vue?vue&type=script&lang=js"
export * from "./MiListItem.vue?vue&type=script&lang=js"

import "./MiListItem.vue?vue&type=style&index=0&id=771a1536&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771a1536"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem});
